import {Directive} from "@angular/core";

@Directive({
    selector: 'ifmSalesforceUid',
    standalone: false
})
export class SalesforceUidDerective {}
